import {
  ACCOUNT_REGISTER_SUCCESS,
  ACCOUNT_UPDATE_SUCCESS,
  ACCOUNT_DETAIL_SUCCESS
} from '../actions/accountActions';

const initialState = {
  users: {
    data: {
      count: 0,
      next: 0,
      previous: 0,
      current: 0,
      results: []
    }
  },
  data: null,
  update: {},
  registered: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ACCOUNT_REGISTER_SUCCESS:
      return {...state, ...action.payload, registered: true};
    case ACCOUNT_UPDATE_SUCCESS:
      return {...state, ...action.payload};
      case ACCOUNT_DETAIL_SUCCESS:
      return {...state, data: action.payload.data};
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/accountReducer.js